import { useQuery } from '@ts-gql/apollo';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import React from 'react';

export const GET_TASK_TYPES_QUERY = gql`
  query GetTaskTypes {
    getTaskTypes {
      cloudId
      name
      isAdhoc
      entityTypes
    }
  }
` as import('../../__generated__/ts-gql/GetTaskTypes').type;

export type GetTaskTypesQueryVariables = OperationVariables<
  typeof GET_TASK_TYPES_QUERY
>;
export type GetTaskTypesQueryResult = OperationData<
  typeof GET_TASK_TYPES_QUERY
>;
export type GetTaskTypesResult = NonNullable<
  GetTaskTypesQueryResult['getTaskTypes']
>[number];

export const useGetTaskTypes = () => {
  const res = useQuery(GET_TASK_TYPES_QUERY, {
    context: { service: 'core' },
  });

  return React.useMemo(() => ({ ...res, data: res.data?.getTaskTypes }), [res]);
};
